module.exports = __webpack_public_path__ + "img/speak1.865b962b.png";